const moduleUpload = {
	namespaced: true,
	state: {
        IS_AGREE: false,
        FINSHED_UPLOAD_STAGE: 1,
        /* 作品相关 */
        TITLE: "",
        TYPE: "",
        AUTHOR: "",
        DESCRIPTION: "",
        // VIDEOID: "",
        THEATER: "",
        GALLERY: ""
	},
	mutations: {
        SET_IS_AGREE: (state, params) => {
            state.IS_AGREE = params
        },
        SET_TYPE: (state, params) => {
            state.TYPE = params
        },
        SET_FINSHED_UPLOAD_STAGE: (state, params) => {
            state.FINSHED_UPLOAD_STAGE = Math.max(state.FINSHED_UPLOAD_STAGE, params)
        },
        SET_ITITLE: (state, params) => {
            state.TITLE = params
        },
        SET_AUTHOR: (state, params) => {
            state.AUTHOR = params
        },
        SET_DESCRIPTION: (state, params) => {
            state.DESCRIPTION = params
        },
        SET_THEATER: (state, params) => {
            state.THEATER = params
        },
        // SET_VIDEOID: (state, params) => {
        //     state.VIDEOID = params
        // },
        SET_GALLERY: (state, params) => {
            state.GALLERY = params
        },
        RESET_UPLOAD: (state) => {
            state.IS_AGREE = false
            state.FINSHED_UPLOAD_STAGE = 1
            state.TITLE = ""
            state.AUTHOR = ""
            state.DESCRIPTION = ""
            state.THEATER = ""
            state.GALLERY = ""
        }
	},
	actions: {
	},
	getters: {
	}
}

export default moduleUpload
